// extracted by mini-css-extract-plugin
export default {"header__title":"Header_header__title__vWoeL","header__description":"Header_header__description__jRGIK","header":"Header_header__IrjF1"};